export class SystemSetting {
	code: string;
	name: string;
	value: string;
	description?: string;
}
